import { render, staticRenderFns } from "./RecruitmentCard.vue?vue&type=template&id=0c7862ff&scoped=true"
import script from "./RecruitmentCard.vue?vue&type=script&lang=js"
export * from "./RecruitmentCard.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentCard.vue?vue&type=style&index=0&id=0c7862ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7862ff",
  null
  
)

export default component.exports